import PureCookieNotice from 'modules/Common/components/CookieNotice';
import {connect} from 'react-redux';
import {getCookie, setCookie} from 'modules/Common/reducers/cookies';
import config from 'config';

const mapStateToProps = state => {
    const cookieName = config.cookiePolicy.cookieName;
    return {
        accepted: state.common.cookies[cookieName]
    }
}

const mapDispatchToProps = dispatch => {
    return {
        acceptCookiePolicy: () => {
            dispatch(setCookie(config.cookiePolicy.cookieName, config.cookiePolicy.cookieValue, {
                path: "/",
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 100))
            }))
        },
        fetchHasAcceptedPolicy() {
            dispatch(getCookie(config.cookiePolicy.cookieName, false))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PureCookieNotice);


// WEBPACK FOOTER //
// ./modules/Common/containers/CookieNotice.js